import { render } from "./MMDashboard.vue?vue&type=template&id=d9791450"
import script from "./MMDashboard.vue?vue&type=script&lang=js"
export * from "./MMDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__